export default function Hero() {
  const tags = ["新剧开播", "红毯高光", "音乐现场", "行业专访", "热搜洞察"];
  return (
    <section id="top" className="relative overflow-hidden" aria-label="首屏介绍">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=editorial%20magazine%20collage%20of%20celebrity%20entertainment%20culture%20with%20dramatic%20camera%20flashes%20and%20film%20frames%2C%20deep%20crimson%20and%20warm%20amber%20tone%2C%20dark%20cinematic%20background%20with%20soft%20glow%20and%20bokeh%2C%20pop%20culture%20headline%20energy&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="明星娱乐资讯编辑部氛围背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/45 to-black/70"></div>
      </div>

      <div className="relative mx-auto flex min-h-[640px] max-w-7xl flex-col items-center justify-center px-4 pb-16 pt-28 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs font-medium tracking-widest text-amber-100 backdrop-blur">
          <i className="ri-record-circle-line text-amber-300" aria-hidden="true"></i>
          LIVE · 持续更新中的娱乐现场
        </span>
        <h1 className="mt-6 max-w-4xl font-serif text-4xl font-black leading-tight text-white md:text-6xl">
          一次看全
          <span className="text-amber-300">明星热点</span>
          的事件脉络
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
          聚合公开报道中的剧集动态、红毯造型、音乐现场与行业长文，按形式与话题分类呈现，帮你快速找到近期热议的娱乐内容，把来龙去脉看得清清楚楚。
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2.5">
          {tags.map((t, i) => (
            <span
              key={t}
              className={`rounded-full px-4 py-1.5 text-sm font-medium backdrop-blur ${
                i === 0 ? "bg-amber2-500 text-white" : "border border-white/25 bg-white/10 text-white/90"
              }`}
            >
              {t}
            </span>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#news"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("news")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-crimson-500 px-7 py-3 text-sm font-semibold text-white transition hover:bg-crimson-600"
          >
            开始阅读今日热点
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
          <a
            href="#trend"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("trend")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/30 bg-white/5 px-7 py-3 text-sm font-semibold text-white backdrop-blur transition hover:bg-white/15"
          >
            查看实时热榜
          </a>
        </div>
      </div>
    </section>
  );
}